import { render, staticRenderFns } from "./SupplierDescription.vue?vue&type=template&id=eb08f9d2&scoped=true"
import script from "./SupplierDescription.vue?vue&type=script&lang=js"
export * from "./SupplierDescription.vue?vue&type=script&lang=js"
import style0 from "./SupplierDescription.vue?vue&type=style&index=0&id=eb08f9d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb08f9d2",
  null
  
)

export default component.exports